import { SelectOptions } from '../../../shared/form/inputs/Select';

export type FixingKitTypeCode = 'InRoofSlate' | 'InRoofTile' | 'OnRoof' | 'FlatRoof';

export const fixingKitTypeCodeOptions: SelectOptions<FixingKitTypeCode> = [
  { value: 'InRoofSlate', text: 'In Roof Slate' },
  { value: 'InRoofTile', text: 'In Roof Tile' },
  { value: 'OnRoof', text: 'On Roof' },
  { value: 'FlatRoof', text: 'Flat Roof' },
];
